export default __webpack_public_path__ + "static/media/Admin.5d4bf883.svg";